import { type ReactNode, useCallback, useState } from 'react'

export type OpenModal = (content: ReactNode, onConfirm: () => void) => void

export interface ModalState {
  content: ReactNode
  onConfirm: () => void
}

export function useModal() {
  const [modalState, setModalState] = useState<ModalState | null>(null)

  const openModal = useCallback<OpenModal>(
    (content, onConfirm) => setModalState({ content, onConfirm }),
    [],
  )
  const closeModal = useCallback(() => setModalState(null), [])

  return { modalState, openModal, closeModal }
}
